
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexs0Elqo0IoM_45ZJOdp3P1pbaMusIniWqeAtrURflVc1kcMeta } from "/usr/src/app/src/app/routes/index/index.vue?macro=true";
import { default as indexZNzV9Zb8S6JDm2tJUw5IQq4xDnH5bCL9DoSitg6YAv4Meta } from "/usr/src/app/src/app/routes/otzyv/index.vue?macro=true";
import { default as indexSf55FUnPL0NXN1gQqp7MCDWUgmo0clPBsPyjdTVO_hcMeta } from "/usr/src/app/src/app/routes/return/index.vue?macro=true";
import { default as indexOOJO9WIpXA0cgLoJMm0iAhKLyBGJmfKPUqSYr21_m6oMeta } from "/usr/src/app/src/app/routes/expertum/index.vue?macro=true";
import { default as indexj6yGDA3WSCkk0HAhA1r9Zunef_45aE51mrCuk3JhhiAUcMeta } from "/usr/src/app/src/app/routes/recommend/index.vue?macro=true";
import { default as indextBQt0honRJrjKipfY8_45E6YEKGMk1qqGQij3V4VnVsWUMeta } from "/usr/src/app/src/app/routes/recommend_adv/index.vue?macro=true";
import { default as indexYNZoLDefkOQWMlZ0vDBjjIXvC7j_2toeW_ovOwwgg1MMeta } from "/usr/src/app/src/app/routes/recommend_dis/index.vue?macro=true";
import { default as indexebk7E7wN2YhDFlwaOQ4QeCT4eSFZuj6f7gx_45lYmaP54Meta } from "/usr/src/app/src/app/routes/recommend_email/index.vue?macro=true";
import { default as indexqBZwCNAG7nJuk1XjrHLiBy1NAIs2BPXOXmKwRBCBFFoMeta } from "/usr/src/app/src/app/routes/consultant-plus/index/index.vue?macro=true";
import { default as indexBmKg_45eyQTtdA4BsOTZQmiSw7_459ez3Zuu8BQpBbh0M0gMeta } from "/usr/src/app/src/app/routes/consultant-plus/prices/index.vue?macro=true";
import { default as indexzIbHua658g6RAWHJTFA_45xEoq8aHGeWqh_eNE7OemN4oMeta } from "/usr/src/app/src/app/routes/consultant-plus/uristu/index.vue?macro=true";
import { default as indexPybXBkUSFyEDO6QwD7ojaT7pyP7LGnUT1sWqKoSityQMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/index.vue?macro=true";
import { default as indexeaevYxn1Zyat1jXOn_452tv5W3VdaaXeNMYQZiqZI_45jDAMeta } from "/usr/src/app/src/app/routes/consultant-plus/kadroviku/index.vue?macro=true";
import { default as indexB4jxjiTN0wpS4m_xoyIJEi892v0Bazs0kPtRqTCWktwMeta } from "/usr/src/app/src/app/routes/consultant-plus/buhgalteru/index.vue?macro=true";
import { default as index3mcb0NbYfhLzUmwR4kSmM3G9xb_45RqhTjIx7jfVQ8K8gMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/index.vue?macro=true";
import { default as indexZlYkuOZwKyejGGiRzH6xzKoucP8jskayX0N5NhMuZyQMeta } from "/usr/src/app/src/app/routes/consultant-plus/get-material/index.vue?macro=true";
import { default as indexzVR7OyLEMaNf7nkkY34GyZkppXhChgQYGFpmDcQO300Meta } from "/usr/src/app/src/app/routes/consultant-plus/rukovoditelu/index.vue?macro=true";
import { default as indexRWXdTY8qDa98_cUQjYouxRLLWL_akhoaq_459kpMrGztEMeta } from "/usr/src/app/src/app/routes/consultant-plus/big-test-drive/index.vue?macro=true";
import { default as indexyyiSlem4Niz80V9cmdhsN6DdMP9aTlco_XEz3saJUlYMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/strimy/index.vue?macro=true";
import { default as indexYOxohxkkLEirM5KHoS8ZfurMpXpATauXzq4La2j6_45UMMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/informer/index.vue?macro=true";
import { default as indexJU_AwBeqollkuGoNWNIoG_45n4w0y3rqro6SrupeguwHQMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/vebinary/index.vue?macro=true";
import { default as indexql_45Q3xL25LzuybFUc7VCfNt_45ZTv7SyTbsV10c3SflpIMeta } from "/usr/src/app/src/app/routes/consultant-plus/special-price_v1/index.vue?macro=true";
import { default as indexLvLUZaiVJ8p2aRjjN0DJTHu47TQPsQBkkymH7hVzdicMeta } from "/usr/src/app/src/app/routes/consultant-plus/special-price_v2/index.vue?macro=true";
import { default as index5sIHicd0nQXnmJlgS_45oY9LW2EOD0e6qv2hAA_45Zqmel8Meta } from "/usr/src/app/src/app/routes/consultant-plus/service/moj-ekspert/index.vue?macro=true";
import { default as indexouTbZ_Q4tMbvaSGcJXt_457gcE13kZm73949MCR_rB0VUMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/ekspress-otvet/index.vue?macro=true";
import { default as indexdk81z7Sm4zurOWBAYySqtlJl2uXz58AgpWkLRJvR_JcMeta } from "/usr/src/app/src/app/routes/consultant-plus/specialist-po-zakupkam/index.vue?macro=true";
import { default as indexeY3MX8iYAE2_45bJ9bHhmUxH5xJm15xv3N_45kfYes5P9HgMeta } from "/usr/src/app/src/app/routes/consultant-plus/demonstraciya-informera/index.vue?macro=true";
import { default as indexW2YTk0PlW0JxjFNYp8nyWtVjiyk140GNTCNBa_FGR2AMeta } from "/usr/src/app/src/app/routes/consultant-plus/probnyj-dostup-besplatno/index.vue?macro=true";
import { default as indexUTJ8RKJb6hiElJB6fDGsH5TkS09XQeLQKegFf06hWjYMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-iskov/index.vue?macro=true";
import { default as indexyi7dflYayqlIcfA_45KtVe4uP_452PbywiHdwdKEGvhsD98Meta } from "/usr/src/app/src/app/routes/consultant-plus/service/avtorskie-seminary/index.vue?macro=true";
import { default as indexo6CAsw4e2rgC_459g1uyxy3W1DHO0noKK5sf9sMqTtoQ0Meta } from "/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-zaprosa/index.vue?macro=true";
import { default as index40CoP5gnUB_dk7ekfyQbqL88OtP3RQNS0zUONY_6zNYMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-dogovora/index.vue?macro=true";
import { default as index13be35W7Wzm8PZzmTQ4OARCBJrDcttFQ_hK71ZhhkREMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/proverka-kontragenta/index.vue?macro=true";
import { default as indexvnY_45we17YangvW0egqsbzkKB06B28tedLdUrW1iOKA0Meta } from "/usr/src/app/src/app/routes/consultant-plus/demonstraciya-konsultantplyus/index.vue?macro=true";
import { default as indexl_gvybWzpnq99oM9UNXT4EclAEofp_45RpA2WuZnBSi04Meta } from "/usr/src/app/src/app/routes/consultant-plus/poluchit-polnyj-prajs-na-2025/index.vue?macro=true";
import { default as indexTnbg8dLa5uq0Axptp0oei747F4Z1fuEKXqtzxddHAa4Meta } from "/usr/src/app/src/app/routes/consultant-plus/poluchite-dostup-k-praktikumu/index.vue?macro=true";
import { default as indexUzjanXOl5_Nt9ILPS3obD4538EnH5k_mdYxkjf5caSsMeta } from "/usr/src/app/src/app/routes/consultant-plus/poprobovat-informer-besplatno/index.vue?macro=true";
import { default as indexeX2ltPs_CSA_4598uu6eq2Z_45a97z_45VMtBQrDKxvq_6x5IMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/pismennye-konsultacii/index.vue?macro=true";
import { default as index_0n8G4uWZHW1jlkhJbiQoIOp8JejVDP9_452ehhnEoHG4Meta } from "/usr/src/app/src/app/routes/consultant-plus/service/individualnye-seminary/index.vue?macro=true";
import { default as indexPtqxcZeYUhNzLmkrBuS24JUCu2jDZ5C212DKDebnyTAMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/kvartalnaya-otchetnost/index.vue?macro=true";
import { default as indexM8R4TMYHl0Wfv7i73mnNLWncTlXEAaGBUYljH3J00awMeta } from "/usr/src/app/src/app/routes/consultant-plus/dostup-k-novshestvu-konsultantplyus/index.vue?macro=true";
import { default as indexu1vxSogTe0y_wXpuUtKBhTreYh4YOny5_45NkSyTBvY9kMeta } from "/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-uchetnoj-politiki/index.vue?macro=true";
import { default as index8LWWeLGRZdmKHzD_iYFH1OUMbRL3K6kNlRQdjrGNlvgMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/sekrety-uspeshnogo-uvolneniya/index.vue?macro=true";
import { default as indexTff_MZpqzF_45w1wXK9PhLnWjah_LMWUDtoE3HKmdgE3IMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/rabota-s-migrantami-po-novym-pravilam/index.vue?macro=true";
import { default as index6swBok3KDbDcwT6LXQqrkDjSLNOisJACSzv2CFVCqXIMeta } from "/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/tandem-dlya-pobedy-v-sude/index.vue?macro=true";
import { default as indexoJlnh39323Lt7tHguyuqFfJj5caMPb8K88Qcublupu0Meta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/nalogovaya-bezopasnost-proverte-svoj-biznes/index.vue?macro=true";
import { default as index69z_45aw_45P4B6LKpzV7TDsgnzKIsy5OTphbbCQZIss6WcMeta } from "/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/tandem-dlya-pobedy-v-sude_v2/index.vue?macro=true";
import { default as index_Y4H1xsOdtKKu4CH84Az_EPu2PD6HD_45kmF0U2iquGBwMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/dogovornye-lovushki-kak-izbezhat-riskov-i-neudach/index.vue?macro=true";
import { default as indexuK8eYJy2FFAugsLBrdG8y4esNKIHiWFdrAF_WkrBS1UMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/kak-nalogovaya-reforma-otrazitsya-na-vashem-biznese/index.vue?macro=true";
import { default as indexElF9mFmKCzTU_2V3JdzE8W8dBYCByxbB7bKeZ_45w_kvEMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/polugodovaya-otchetnost-2025-sdaem-bez-oshibok-i-shtrafov/index.vue?macro=true";
import { default as indexSnter5m_45WH0dgSy8PooxRxQ_1412CGyDl_FNxfCZOwwMeta } from "/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/vashi-dogovory-menshe-riskov-bolshe-vygody/index.vue?macro=true";
import { default as indexGsGPXlvjC0GfESA8P50fm8udM73e83Jg_45WHhYyWGtXIMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/kameralnye-proverki-kak-nalogovaya-proverit-vashu-otchetnost/index.vue?macro=true";
import { default as indexZgKn9OhcjvVp5RWJBJcNB3Wd3px2_0tKPiAYEwAxYwUMeta } from "/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/vashi-dogovory-menshe-riskov-bolshe-vygody_v2/index.vue?macro=true";
import { default as indexkeYIAC07Vi2aNAj2zPHJADG56Kf0i6uzr6bZUOfROJcMeta } from "/usr/src/app/src/app/routes/consultant-plus/praktikumy/kak-izbezhat-shtrafov-za-persdannye-reklamu-i-massovye-zvonki/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/src/app/routes/index/index.vue")
  },
  {
    name: "otzyv",
    path: "/otzyv",
    meta: indexZNzV9Zb8S6JDm2tJUw5IQq4xDnH5bCL9DoSitg6YAv4Meta || {},
    component: () => import("/usr/src/app/src/app/routes/otzyv/index.vue")
  },
  {
    name: "return",
    path: "/return",
    meta: indexSf55FUnPL0NXN1gQqp7MCDWUgmo0clPBsPyjdTVO_hcMeta || {},
    component: () => import("/usr/src/app/src/app/routes/return/index.vue")
  },
  {
    name: "expertum",
    path: "/expertum",
    meta: indexOOJO9WIpXA0cgLoJMm0iAhKLyBGJmfKPUqSYr21_m6oMeta || {},
    component: () => import("/usr/src/app/src/app/routes/expertum/index.vue")
  },
  {
    name: "recommend",
    path: "/recommend",
    meta: indexj6yGDA3WSCkk0HAhA1r9Zunef_45aE51mrCuk3JhhiAUcMeta || {},
    component: () => import("/usr/src/app/src/app/routes/recommend/index.vue")
  },
  {
    name: "recommend_adv",
    path: "/recommend_adv",
    meta: indextBQt0honRJrjKipfY8_45E6YEKGMk1qqGQij3V4VnVsWUMeta || {},
    component: () => import("/usr/src/app/src/app/routes/recommend_adv/index.vue")
  },
  {
    name: "recommend_dis",
    path: "/recommend_dis",
    meta: indexYNZoLDefkOQWMlZ0vDBjjIXvC7j_2toeW_ovOwwgg1MMeta || {},
    component: () => import("/usr/src/app/src/app/routes/recommend_dis/index.vue")
  },
  {
    name: "recommend_email",
    path: "/recommend_email",
    meta: indexebk7E7wN2YhDFlwaOQ4QeCT4eSFZuj6f7gx_45lYmaP54Meta || {},
    component: () => import("/usr/src/app/src/app/routes/recommend_email/index.vue")
  },
  {
    name: "consultant-plus-index",
    path: "/consultant-plus",
    meta: indexqBZwCNAG7nJuk1XjrHLiBy1NAIs2BPXOXmKwRBCBFFoMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/index/index.vue")
  },
  {
    name: "consultant-plus-prices",
    path: "/consultant-plus/prices",
    meta: indexBmKg_45eyQTtdA4BsOTZQmiSw7_459ez3Zuu8BQpBbh0M0gMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/prices/index.vue")
  },
  {
    name: "consultant-plus-uristu",
    path: "/consultant-plus/uristu",
    meta: indexzIbHua658g6RAWHJTFA_45xEoq8aHGeWqh_eNE7OemN4oMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/uristu/index.vue")
  },
  {
    name: "consultant-plus-service",
    path: "/consultant-plus/service",
    meta: indexPybXBkUSFyEDO6QwD7ojaT7pyP7LGnUT1sWqKoSityQMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/index.vue")
  },
  {
    name: "consultant-plus-kadroviku",
    path: "/consultant-plus/kadroviku",
    meta: indexeaevYxn1Zyat1jXOn_452tv5W3VdaaXeNMYQZiqZI_45jDAMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/kadroviku/index.vue")
  },
  {
    name: "consultant-plus-buhgalteru",
    path: "/consultant-plus/buhgalteru",
    meta: indexB4jxjiTN0wpS4m_xoyIJEi892v0Bazs0kPtRqTCWktwMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/buhgalteru/index.vue")
  },
  {
    name: "consultant-plus-praktikumy",
    path: "/consultant-plus/praktikumy",
    meta: index3mcb0NbYfhLzUmwR4kSmM3G9xb_45RqhTjIx7jfVQ8K8gMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/index.vue")
  },
  {
    name: "consultant-plus-get-material",
    path: "/consultant-plus/get-material",
    meta: { ...(indexZlYkuOZwKyejGGiRzH6xzKoucP8jskayX0N5NhMuZyQMeta || {}), ...{"middleware":["redirect‑check"]} },
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/get-material/index.vue")
  },
  {
    name: "consultant-plus-rukovoditelu",
    path: "/consultant-plus/rukovoditelu",
    meta: indexzVR7OyLEMaNf7nkkY34GyZkppXhChgQYGFpmDcQO300Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/rukovoditelu/index.vue")
  },
  {
    name: "consultant-plus-big-test-drive",
    path: "/consultant-plus/big-test-drive",
    meta: indexRWXdTY8qDa98_cUQjYouxRLLWL_akhoaq_459kpMrGztEMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/big-test-drive/index.vue")
  },
  {
    name: "consultant-plus-service-strimy",
    path: "/consultant-plus/service/strimy",
    meta: indexyyiSlem4Niz80V9cmdhsN6DdMP9aTlco_XEz3saJUlYMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/strimy/index.vue")
  },
  {
    name: "consultant-plus-service-informer",
    path: "/consultant-plus/service/informer",
    meta: indexYOxohxkkLEirM5KHoS8ZfurMpXpATauXzq4La2j6_45UMMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/informer/index.vue")
  },
  {
    name: "consultant-plus-service-vebinary",
    path: "/consultant-plus/service/vebinary",
    meta: indexJU_AwBeqollkuGoNWNIoG_45n4w0y3rqro6SrupeguwHQMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/vebinary/index.vue")
  },
  {
    name: "consultant-plus-special-price_v1",
    path: "/consultant-plus/special-price_v1",
    meta: indexql_45Q3xL25LzuybFUc7VCfNt_45ZTv7SyTbsV10c3SflpIMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/special-price_v1/index.vue")
  },
  {
    name: "consultant-plus-special-price_v2",
    path: "/consultant-plus/special-price_v2",
    meta: indexLvLUZaiVJ8p2aRjjN0DJTHu47TQPsQBkkymH7hVzdicMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/special-price_v2/index.vue")
  },
  {
    name: "consultant-plus-service-moj-ekspert",
    path: "/consultant-plus/service/moj-ekspert",
    meta: index5sIHicd0nQXnmJlgS_45oY9LW2EOD0e6qv2hAA_45Zqmel8Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/moj-ekspert/index.vue")
  },
  {
    name: "consultant-plus-service-ekspress-otvet",
    path: "/consultant-plus/service/ekspress-otvet",
    meta: indexouTbZ_Q4tMbvaSGcJXt_457gcE13kZm73949MCR_rB0VUMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/ekspress-otvet/index.vue")
  },
  {
    name: "consultant-plus-specialist-po-zakupkam",
    path: "/consultant-plus/specialist-po-zakupkam",
    meta: indexdk81z7Sm4zurOWBAYySqtlJl2uXz58AgpWkLRJvR_JcMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/specialist-po-zakupkam/index.vue")
  },
  {
    name: "consultant-plus-demonstraciya-informera",
    path: "/consultant-plus/demonstraciya-informera",
    meta: indexeY3MX8iYAE2_45bJ9bHhmUxH5xJm15xv3N_45kfYes5P9HgMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/demonstraciya-informera/index.vue")
  },
  {
    name: "consultant-plus-probnyj-dostup-besplatno",
    path: "/consultant-plus/probnyj-dostup-besplatno",
    meta: indexW2YTk0PlW0JxjFNYp8nyWtVjiyk140GNTCNBa_FGR2AMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/probnyj-dostup-besplatno/index.vue")
  },
  {
    name: "consultant-plus-service-podgotovka-iskov",
    path: "/consultant-plus/service/podgotovka-iskov",
    meta: indexUTJ8RKJb6hiElJB6fDGsH5TkS09XQeLQKegFf06hWjYMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-iskov/index.vue")
  },
  {
    name: "consultant-plus-service-avtorskie-seminary",
    path: "/consultant-plus/service/avtorskie-seminary",
    meta: indexyi7dflYayqlIcfA_45KtVe4uP_452PbywiHdwdKEGvhsD98Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/avtorskie-seminary/index.vue")
  },
  {
    name: "consultant-plus-service-podgotovka-zaprosa",
    path: "/consultant-plus/service/podgotovka-zaprosa",
    meta: indexo6CAsw4e2rgC_459g1uyxy3W1DHO0noKK5sf9sMqTtoQ0Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-zaprosa/index.vue")
  },
  {
    name: "consultant-plus-service-podgotovka-dogovora",
    path: "/consultant-plus/service/podgotovka-dogovora",
    meta: index40CoP5gnUB_dk7ekfyQbqL88OtP3RQNS0zUONY_6zNYMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-dogovora/index.vue")
  },
  {
    name: "consultant-plus-service-proverka-kontragenta",
    path: "/consultant-plus/service/proverka-kontragenta",
    meta: index13be35W7Wzm8PZzmTQ4OARCBJrDcttFQ_hK71ZhhkREMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/proverka-kontragenta/index.vue")
  },
  {
    name: "consultant-plus-demonstraciya-konsultantplyus",
    path: "/consultant-plus/demonstraciya-konsultantplyus",
    meta: indexvnY_45we17YangvW0egqsbzkKB06B28tedLdUrW1iOKA0Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/demonstraciya-konsultantplyus/index.vue")
  },
  {
    name: "consultant-plus-poluchit-polnyj-prajs-na-2025",
    path: "/consultant-plus/poluchit-polnyj-prajs-na-2025",
    meta: indexl_gvybWzpnq99oM9UNXT4EclAEofp_45RpA2WuZnBSi04Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/poluchit-polnyj-prajs-na-2025/index.vue")
  },
  {
    name: "consultant-plus-poluchite-dostup-k-praktikumu",
    path: "/consultant-plus/poluchite-dostup-k-praktikumu",
    meta: indexTnbg8dLa5uq0Axptp0oei747F4Z1fuEKXqtzxddHAa4Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/poluchite-dostup-k-praktikumu/index.vue")
  },
  {
    name: "consultant-plus-poprobovat-informer-besplatno",
    path: "/consultant-plus/poprobovat-informer-besplatno",
    meta: indexUzjanXOl5_Nt9ILPS3obD4538EnH5k_mdYxkjf5caSsMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/poprobovat-informer-besplatno/index.vue")
  },
  {
    name: "consultant-plus-service-pismennye-konsultacii",
    path: "/consultant-plus/service/pismennye-konsultacii",
    meta: indexeX2ltPs_CSA_4598uu6eq2Z_45a97z_45VMtBQrDKxvq_6x5IMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/pismennye-konsultacii/index.vue")
  },
  {
    name: "consultant-plus-service-individualnye-seminary",
    path: "/consultant-plus/service/individualnye-seminary",
    meta: index_0n8G4uWZHW1jlkhJbiQoIOp8JejVDP9_452ehhnEoHG4Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/individualnye-seminary/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-kvartalnaya-otchetnost",
    path: "/consultant-plus/praktikumy/kvartalnaya-otchetnost",
    meta: indexPtqxcZeYUhNzLmkrBuS24JUCu2jDZ5C212DKDebnyTAMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/kvartalnaya-otchetnost/index.vue")
  },
  {
    name: "consultant-plus-dostup-k-novshestvu-konsultantplyus",
    path: "/consultant-plus/dostup-k-novshestvu-konsultantplyus",
    meta: indexM8R4TMYHl0Wfv7i73mnNLWncTlXEAaGBUYljH3J00awMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/dostup-k-novshestvu-konsultantplyus/index.vue")
  },
  {
    name: "consultant-plus-service-podgotovka-uchetnoj-politiki",
    path: "/consultant-plus/service/podgotovka-uchetnoj-politiki",
    meta: indexu1vxSogTe0y_wXpuUtKBhTreYh4YOny5_45NkSyTBvY9kMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/service/podgotovka-uchetnoj-politiki/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-sekrety-uspeshnogo-uvolneniya",
    path: "/consultant-plus/praktikumy/sekrety-uspeshnogo-uvolneniya",
    meta: index8LWWeLGRZdmKHzD_iYFH1OUMbRL3K6kNlRQdjrGNlvgMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/sekrety-uspeshnogo-uvolneniya/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-rabota-s-migrantami-po-novym-pravilam",
    path: "/consultant-plus/praktikumy/rabota-s-migrantami-po-novym-pravilam",
    meta: indexTff_MZpqzF_45w1wXK9PhLnWjah_LMWUDtoE3HKmdgE3IMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/rabota-s-migrantami-po-novym-pravilam/index.vue")
  },
  {
    name: "consultant-plus-novshestva-konsultantplyus-tandem-dlya-pobedy-v-sude",
    path: "/consultant-plus/novshestva-konsultantplyus/tandem-dlya-pobedy-v-sude",
    meta: index6swBok3KDbDcwT6LXQqrkDjSLNOisJACSzv2CFVCqXIMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/tandem-dlya-pobedy-v-sude/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-nalogovaya-bezopasnost-proverte-svoj-biznes",
    path: "/consultant-plus/praktikumy/nalogovaya-bezopasnost-proverte-svoj-biznes",
    meta: indexoJlnh39323Lt7tHguyuqFfJj5caMPb8K88Qcublupu0Meta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/nalogovaya-bezopasnost-proverte-svoj-biznes/index.vue")
  },
  {
    name: "consultant-plus-novshestva-konsultantplyus-tandem-dlya-pobedy-v-sude_v2",
    path: "/consultant-plus/novshestva-konsultantplyus/tandem-dlya-pobedy-v-sude_v2",
    meta: index69z_45aw_45P4B6LKpzV7TDsgnzKIsy5OTphbbCQZIss6WcMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/tandem-dlya-pobedy-v-sude_v2/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-dogovornye-lovushki-kak-izbezhat-riskov-i-neudach",
    path: "/consultant-plus/praktikumy/dogovornye-lovushki-kak-izbezhat-riskov-i-neudach",
    meta: index_Y4H1xsOdtKKu4CH84Az_EPu2PD6HD_45kmF0U2iquGBwMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/dogovornye-lovushki-kak-izbezhat-riskov-i-neudach/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-kak-nalogovaya-reforma-otrazitsya-na-vashem-biznese",
    path: "/consultant-plus/praktikumy/kak-nalogovaya-reforma-otrazitsya-na-vashem-biznese",
    meta: indexuK8eYJy2FFAugsLBrdG8y4esNKIHiWFdrAF_WkrBS1UMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/kak-nalogovaya-reforma-otrazitsya-na-vashem-biznese/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-polugodovaya-otchetnost-2025-sdaem-bez-oshibok-i-shtrafov",
    path: "/consultant-plus/praktikumy/polugodovaya-otchetnost-2025-sdaem-bez-oshibok-i-shtrafov",
    meta: indexElF9mFmKCzTU_2V3JdzE8W8dBYCByxbB7bKeZ_45w_kvEMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/polugodovaya-otchetnost-2025-sdaem-bez-oshibok-i-shtrafov/index.vue")
  },
  {
    name: "consultant-plus-novshestva-konsultantplyus-vashi-dogovory-menshe-riskov-bolshe-vygody",
    path: "/consultant-plus/novshestva-konsultantplyus/vashi-dogovory-menshe-riskov-bolshe-vygody",
    meta: indexSnter5m_45WH0dgSy8PooxRxQ_1412CGyDl_FNxfCZOwwMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/vashi-dogovory-menshe-riskov-bolshe-vygody/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-kameralnye-proverki-kak-nalogovaya-proverit-vashu-otchetnost",
    path: "/consultant-plus/praktikumy/kameralnye-proverki-kak-nalogovaya-proverit-vashu-otchetnost",
    meta: indexGsGPXlvjC0GfESA8P50fm8udM73e83Jg_45WHhYyWGtXIMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/kameralnye-proverki-kak-nalogovaya-proverit-vashu-otchetnost/index.vue")
  },
  {
    name: "consultant-plus-novshestva-konsultantplyus-vashi-dogovory-menshe-riskov-bolshe-vygody_v2",
    path: "/consultant-plus/novshestva-konsultantplyus/vashi-dogovory-menshe-riskov-bolshe-vygody_v2",
    meta: indexZgKn9OhcjvVp5RWJBJcNB3Wd3px2_0tKPiAYEwAxYwUMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/novshestva-konsultantplyus/vashi-dogovory-menshe-riskov-bolshe-vygody_v2/index.vue")
  },
  {
    name: "consultant-plus-praktikumy-kak-izbezhat-shtrafov-za-persdannye-reklamu-i-massovye-zvonki",
    path: "/consultant-plus/praktikumy/kak-izbezhat-shtrafov-za-persdannye-reklamu-i-massovye-zvonki",
    meta: indexkeYIAC07Vi2aNAj2zPHJADG56Kf0i6uzr6bZUOfROJcMeta || {},
    component: () => import("/usr/src/app/src/app/routes/consultant-plus/praktikumy/kak-izbezhat-shtrafov-za-persdannye-reklamu-i-massovye-zvonki/index.vue")
  }
]